<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'app',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  created() {
    // 在应用创建时检查是否为移动设备
    this.$store.dispatch(this.$action.CHECK_IS_MOBILE);
    
    // 监听窗口大小变化，重新检查是否为移动设备
    window.addEventListener('resize', this.handleResize);
    
    // 初始化移动端防拖动功能
    this.initMobilePreventDrag();
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    handleResize() {
      // 窗口大小变化时重新检查是否为移动设备
      this.$store.dispatch(this.$action.CHECK_IS_MOBILE);
      
      // 重新应用移动端防拖动样式
      this.applyMobilePreventDrag();
    },
    initMobilePreventDrag() {
      // 检查是否为移动设备并应用防拖动样式
      this.applyMobilePreventDrag();
      
      // 监听移动设备检测变化
      this.$watch(
        () => this.$store.state.isMobile,
        (newVal) => {
          this.applyMobilePreventDrag();
        }
      );
    },
    applyMobilePreventDrag() {
      const isMobile = this.$store.state.isMobile;
      const body = document.body;
      const app = document.getElementById('app');
      
      if (isMobile) {
        // 添加移动端样式类
        body.classList.add('mobile-device');
        if (app) {
          app.classList.add('mobile-device');
        }
        
        // 禁用触摸事件的默认行为
        this.preventTouchDefault();
        
        // 禁用上下文菜单
        this.disableContextMenu();
      } else {
        // 移除移动端样式类
        body.classList.remove('mobile-device');
        if (app) {
          app.classList.remove('mobile-device');
        }
        
        // 恢复触摸事件的默认行为
        this.restoreTouchDefault();
        
        // 恢复上下文菜单
        this.restoreContextMenu();
      }
    },
    preventTouchDefault() {
      // 防止触摸事件的默认行为
      this.preventDefaultHandler = (e) => {
        if (e.touches.length > 1) {
          e.preventDefault();
        }
      };
      
      // 防止下拉刷新
      this.preventPullToRefreshHandler = (e) => {
        if (e.touches.length === 1) {
          e.preventDefault();
        }
      };
      
      // 防止页面滚动
      this.preventScrollHandler = (e) => {
        e.preventDefault();
      };
      
      // 防止多点触控缩放
      document.addEventListener('touchstart', this.preventDefaultHandler, { passive: false });
      document.addEventListener('touchmove', this.preventDefaultHandler, { passive: false });
      
      // 防止下拉刷新
      document.addEventListener('touchmove', this.preventPullToRefreshHandler, { passive: false });
      
      // 防止页面滚动
      document.addEventListener('scroll', this.preventScrollHandler, { passive: false });
    },
    restoreTouchDefault() {
      // 移除所有触摸事件监听器
      if (this.preventDefaultHandler) {
        document.removeEventListener('touchstart', this.preventDefaultHandler);
        document.removeEventListener('touchmove', this.preventDefaultHandler);
      }
      if (this.preventPullToRefreshHandler) {
        document.removeEventListener('touchmove', this.preventPullToRefreshHandler);
      }
      if (this.preventScrollHandler) {
        document.removeEventListener('scroll', this.preventScrollHandler);
      }
    },
    disableContextMenu() {
      // 禁用上下文菜单
      document.addEventListener('contextmenu', this.preventDefaultContextMenu);
    },
    restoreContextMenu() {
      // 恢复上下文菜单
      document.removeEventListener('contextmenu', this.preventDefaultContextMenu);
    },
    preventDefaultContextMenu(e) {
      e.preventDefault();
      return false;
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
  /* 移动端防拖动和下拉刷新样式 */
  &.mobile-device {
    /* 禁用页面滚动 */
    overflow: hidden;
    height: 100vh;
    
    /* 禁用触摸拖动 */
    touch-action: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    
    /* 禁用长按菜单 */
    -webkit-tap-highlight-color: transparent;
    
    /* 防止页面缩放 */
    -webkit-text-size-adjust: none;
    -ms-text-size-adjust: none;
    text-size-adjust: none;
  }
}

body {
  margin: 0;
  
  /* 移动端防拖动和下拉刷新样式 */
  &.mobile-device {
    /* 禁用页面滚动 */
    overflow: hidden;
    height: 100vh;
    
    /* 禁用触摸拖动 */
    touch-action: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    
    /* 禁用弹性滚动 */
    overscroll-behavior: none;
    -webkit-overflow-scrolling: none;
    
    /* 防止页面缩放 */
    -webkit-text-size-adjust: none;
    -ms-text-size-adjust: none;
    text-size-adjust: none;
    
    /* 禁用长按菜单 */
    -webkit-tap-highlight-color: transparent;
  }
}

.el-textarea__inner {
  border-radius: 0 !important;
}

.el-input-group__append {
  border-radius: 0 !important;
}

.setting-list {
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .setting-btn {
    line-height: 27px;
    padding: 0 15px;
    font-size: 13px;
    color: #606266;
    cursor: pointer;
    outline: 0;
  }

  .setting-btn:hover {
    background-color: #e6f9fc;
    color: #33cde5;
  }
}

#test {
  width: 80px;
}

@import "assets/font/iconfont.css";
@import "assets/font2/iconfont.css";

.iconfont {
  color: white;
  margin: 0 3px;
}

span:focus {
  outline-style: none;
}

.home-main::-webkit-scrollbar {
  display: none
}

textarea::-webkit-scrollbar {
  display: none
}

.el-input__inner {
  border-radius: 0 !important;
}

.popup-flex {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.el-pager li {
  color: #409EFF;
}

.el-popover {
  min-width: 100px !important;
}

.el-pager li.active {
  color: black !important;
}

.search-btn {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
}

.search-btn-pre {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.el-dialog__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;

  .el-dialog {
    margin: 15vh 0;
  }
}

#system-setting {
  .el-dialog__header {
    text-align: left;
    font-weight: bold;
  }

  .el-dialog__body {
    margin-top: -20px;
    /*background-color: #333333;*/
  }

  /*.el-tabs__nav{*/
  /*display: flex !important;*/
  /*flex-wrap: wrap !important;*/
  /*}*/
  .el-tabs {
    width: 95% !important; //固定宽度

    .el-tabs__nav {
      display: flex !important;
      flex-wrap: wrap !important;
    }
  }

  .el-tabs__nav-wrap::after {
    position: static !important;
  }

  .el-tabs__active-bar {
    background-color: transparent !important;
  }

}


.el-submenu__title {
  text-align: left;
}

.el-menu-item {
  text-align: left;
}


.el-button {
  border-radius: 0 !important;
}

.confirm-btn-blue {
  color: #FFF !important;
  background-color: #409EFF !important;
  border-color: #409EFF !important;
}

.el-icon-c-blue:before {
  content: "\e7a3";
  color: #409EFF;
}

.confirm-btn-yellow {
  color: #FFF !important;
  background-color: #E5A13C !important;
  border-color: #E5A13C !important;
}

.el-icon-c-yellow:before {
  content: "\e7a3";
  color: #E5A13C;
}

.confirm-btn-red {
  color: #FFF !important;
  background-color: #F46C6C !important;
  border-color: #F46C6C !important;
}

.el-icon-c-red:before {
  content: "\e7a3";
  color: #F46C6C;
}

/* ssh */
#ssh {
  .el-tabs__header {
    margin-bottom: 0 !important;
  }

  .el-tabs__content {
    flex-grow: 1;
  }

  .el-tabs__item {
    height: auto !important;
    line-height: normal !important;
    color: white !important;
    font-size: 13px !important;
  }

  .el-tabs--card>.el-tabs__header .el-tabs__nav {
    border-radius: 0 !important;
    border-left: 0.5px solid #E4E7ED !important;
    border-right: 0.5px solid #E4E7ED !important;
    border-top: 0.5px solid #E4E7ED !important;
  }

  .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    border-bottom: 0.5px solid #000 !important;
    background-color: #000;
  }

  .el-tabs--card>.el-tabs__header {
    border-bottom: 0.5px solid #E4E7ED !important;
  }
}

.snapshot-main-head {
  .el-checkbox {
    display: flex;
    align-items: center;
  }

  .el-checkbox__label {
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 5px !important;
  }

  .el-checkbox__input {
    display: flex;
    align-items: center;
  }
}

.device {
  .el-button {
    padding: 5px 7px;
  }
}

.el-loading-mask {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.redItem .el-form-item__label {
  color: red;
}

/*1.显示滚动条：当内容超出容器的时候，可以拖动：*/
.el-drawer__body {
  overflow: auto;
}

/*2.隐藏滚动条，太丑了*/
.el-drawer__container ::-webkit-scrollbar {
  display: none;
}

.model-switch .el-switch__label,
.ipproxy-switch .el-switch__label {
  position: absolute;
  display: none;
  color: #fff;
}

.model-switch .el-switch__label--right,
.ipproxy-switch .el-switch__label--right {
  z-index: 1;
  left: -4px;
}

.model-switch .el-switch__label--left,
.ipproxy-switch .el-switch__label--left {
  z-index: 1;
  left: 21px;
}

.model-switch .el-switch__label.is-active,
.ipproxy-switch .el-switch__label.is-active {
  display: block;
}

*::-webkit-scrollbar {
  width: 7px;
  height: 10px;
  background-color: transparent;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
*::-webkit-scrollbar-track {
  background-color: #f0f6ff;
}

/*定义滚动条轨道 内阴影+圆角*/
*::-webkit-scrollbar-thumb {
  background-color: #73abb1;
  border-radius: 6px;
}

/*定义滑块 内阴影+圆角*/
.scrollbarHide::-webkit-scrollbar {
  display: none
}

.scrollbarShow::-webkit-scrollbar {
  display: block
}
</style>
